import React from 'react'
import { Field } from 'redux-form';
import { Item, InputPicker, painel } from 'scorpion-core';
// import { required } from '../function';

import EditorCodigo from '../../editor/EditorCodigo'



function componentRelEspelho(comp, dados) {
    return painel([
        [{ style: "cellTitulo", text: comp.label }], [{ style: "cellValor", text: dados[comp.field] }]
    ], { widths: ['*'] })

}
function toStringItemFunc(item, index) {
    return item;
}

function component(item, propsG) {
    // if (item.requerido){
    //     return (<Item key={item.sha} style={{ flex: 1 }}>
    //         <Field name={item.field} placeholder={item.label} itens={item.opcoes} toStringItem={(item) => item} component={InputPicker} validade={[required]} {...item.propsadd}/>
    //     </Item>)
    // }
    let v = null;
    let valores = null;
    if (propsG) {
        const { atualValues } = propsG;
        valores = atualValues;
        if (item.field.startsWith('DebugValues') && atualValues && atualValues.DebugValues) {
            valores = atualValues.DebugValues;
        }
    }
    let tmpFunc = null;
    try {
        tmpFunc = new Function("return " + item.toStringItem)(); 
    } catch (error) {
        // console.log('error', error);
    } 

    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} placeholder={item.label} component={(props) => {
            const { input: { value, onChange } } = props;
            if (valores) {



                let conteudoAjustado = "logica(valores,propsG,value);"
                conteudoAjustado += item.logica;
                try {
                    v = eval(conteudoAjustado);
                } catch (error) {
                    // console.log('error', error);
                }
                try {
                    v = eval(conteudoAjustado);
                } catch (error) {
                    // console.log('error', error);
                }

            }

            return <InputPicker {...props} itens={v} toStringItem={tmpFunc || (item => item)} />
        }} {...item.propsadd} />
    </Item>)
}

const modelo = {
    field: "combo",
    label: "Itens",
    typeComponente: "ComboBoxItens",

    requerido: false,
    logica: `function logica(atualValues, propsG, value) {    
    return ["a","b"];
}`,
    toStringItem: `function toStringItemFunc(item,index) {    
    return item;
}`
}

const comp = {
    typeComponente: "ComboBoxItens",
    configView: {
        nome: "ComboBox Lógico",
        modelo,
        editores: {
            
            logica: EditorCodigo,
            toStringItem: EditorCodigo,
        },
        
    },
    componentRelEspelho,
    component
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/ComboxItens/index.js